// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"232":"LeaderboardScreen","346":"SignupNameScreen","467":"QuestionsComplete","639":"QuestionScreenV2"}[chunkId] + "." + {"232":"9cb6970d","346":"4327be56","467":"397939bb","639":"a8095163"}[chunkId] + ".chunk.css";
};